export enum QuestStates {
	AVAILABLE = "AVAILABLE",
	ACCEPTED_UNFINISHED = "ACCEPTED_UNFINISHED",
	ACCEPTED_FINISHED = "ACCEPTED_FINISHED",
	COMPLETED = "COMPLETED",
}

export enum QuestInProgressStates {
	NON_EXISTING = 0,
	IN_PROGRESS = 1,
	FINISHED = 2,
}
